/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinksarchived2Inputs */

const en_downloadlinksarchived2 = /** @type {(inputs: Downloadlinksarchived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link archived`)
};

const de_downloadlinksarchived2 = /** @type {(inputs: Downloadlinksarchived2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link archiviert`)
};

/**
* | output |
* | --- |
* | "Link archived" |
*
* @param {Downloadlinksarchived2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinksarchived2 = /** @type {((inputs?: Downloadlinksarchived2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinksarchived2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinksarchived2(inputs)
	return de_downloadlinksarchived2(inputs)
});
export { downloadlinksarchived2 as "downloadLinksArchived" }